import React, { useState } from "react";
import axios from "axios";
import baseUrl from "../../../baseUrl";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../Spinner/Spinner";

const AddQuestion = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const { id } = useParams();

  const [showModal, setShowModal] = useState(false);

  const [writttenQuestion, setWrittenQuestion] = useState("");
  const [MCQQuestion, setMCQQuestion] = useState("");

  const [MCQOptionOne, setMCQOptionOne] = useState("");
  const [MCQOptionTwo, setMCQOptionTwo] = useState("");
  const [MCQOptionThree, setMCQOptionThree] = useState("");
  const [MCQOptionFour, setMCQOptionFour] = useState("");
  const [MCQCorrectAnswer, setMCQCorrectAnswer] = useState("");

  const [loading, setLoading] = useState(false);

  const clearFields = () => {
    setWrittenQuestion("");
    setMCQQuestion("");
    setMCQOptionOne("");
    setMCQOptionTwo("");
    setMCQOptionThree("");
    setMCQOptionFour("");
    setMCQCorrectAnswer("");
  };

  const navigate = useNavigate();

  // handle submit for create exam
  const handleSubmit = (e) => {
    e.preventDefault();

    if (isActive === false) {
      setLoading(true);
      axios
        .post(
          `${baseUrl}/admin/add-questions`,
          {
            examId: id,
            question: MCQQuestion,
            optionOne: MCQOptionOne,
            optionTwo: MCQOptionTwo,
            optionThree: MCQOptionThree,
            optionFour: MCQOptionFour,
            correctOption: MCQCorrectAnswer,
            questionType: "MCQ",
          },
          {
            headers: {
              Authorization: `Bearer ${adminToken}`,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.success === true) {
            toast.success(res.data.message);
            navigate("/admin/exam-details/" + id);
            clearFields();
            window.location.reload();
          } else {
            toast.error(res.data.message);
            navigate("/admin/exam-details/" + id);
            clearFields();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(true);
      axios
        .post(
          `${baseUrl}/admin/add-questions`,
          {
            examId: id,
            question: writttenQuestion,
            optionOne: "N/A",
            optionTwo: "N/A",
            optionThree: "N/A",
            optionFour: "N/A",
            correctOption: "N/A",
            questionType: "Written",
          },
          {
            headers: {
              Authorization: `Bearer ${adminToken}`,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.success === true) {
            toast.success(res.data.message);
            navigate("/admin/exam-details/" + id);
            clearFields();
            window.location.reload();
          } else {
            toast.error(res.data.message);
            navigate("/admin/exam-details/" + id);
            clearFields();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }

    setShowModal(false);
  };

  const [isActive, setActive] = useState("false");
  const handleToggle = () => {
    setActive(!isActive);
  };

  return (
    <>
      {loading && <Spinner />}
      <button
        className="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
        type="button"
        onClick={() => setShowModal(true)}
      >
        <i className="fa-solid fa-plus mr-1"></i> Add Questions
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex flex-col items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold">Add Questions</h3>

                  <button
                    className="bg-indigo-500 text-white active:bg-indigo-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={handleToggle}
                  >
                    {isActive ? "MCQ" : "Written"}
                  </button>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>

                {/*body*/}
                <form onSubmit={handleSubmit}>
                  {isActive ? (
                    <div className="relative p-6 flex-auto">
                      <label
                        className="block mb-2 text-sm font-bold text-gray-700"
                        htmlFor="examTitle"
                      >
                        Written Question
                      </label>
                      <textarea
                        className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-green-500 border-green-300 focus:shadow-outline"
                        type="text"
                        name="writttenQuestion"
                        value={writttenQuestion}
                        onChange={(e) => setWrittenQuestion(e.target.value)}
                        required
                        rows="7"
                        cols="60"
                      />
                    </div>
                  ) : (
                    <div>
                      <div className="relative p-6 flex-auto">
                        <label
                          className="block mb-2 text-sm font-bold text-gray-700"
                          htmlFor="examTitle"
                        >
                          MCQ Question
                        </label>
                        <textarea
                          className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-green-500 border-green-300 focus:shadow-outline"
                          type="text"
                          name="MCQQuestion"
                          value={MCQQuestion}
                          onChange={(e) => setMCQQuestion(e.target.value)}
                          required
                          rows="1"
                          cols="60"
                        />
                      </div>
                      <div className="mb-1 ml-10 md:flex">
                        <div className="mb-4 md:mr-2 md:mb-0 ml-2">
                          <label className="block mb-2 text-sm font-bold text-gray-700">
                            Option One
                          </label>
                          <input
                            className="w-full px-3 py-2 text-sm leading-tight focus:outline-green-500 border-green-300 text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            name="MCQOptionOne"
                            value={MCQOptionOne}
                            onChange={(e) => setMCQOptionOne(e.target.value)}
                            required
                          />
                        </div>
                        <div className="mb-4 md:mr-2 md:mb-0">
                          <label className="block mb-2 text-sm font-bold text-gray-700">
                            Option Two
                          </label>
                          <input
                            className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            name="MCQOptionTwo"
                            value={MCQOptionTwo}
                            onChange={(e) => setMCQOptionTwo(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="mb-1 ml-10 md:flex">
                        <div className="mb-1 md:mr-2 md:mb-0">
                          <label className="block mb-2 text-sm font-bold text-gray-700">
                            Option Three
                          </label>
                          <input
                            className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            name="MCQOptionThree"
                            value={MCQOptionThree}
                            onChange={(e) => setMCQOptionThree(e.target.value)}
                            required
                          />
                        </div>
                        <div className="mb-4 md:mr-2 md:mb-0">
                          <label className="block mb-2 text-sm font-bold text-gray-700">
                            Option Four
                          </label>
                          <input
                            className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            name="MCQOptionFour"
                            value={MCQOptionFour}
                            onChange={(e) => setMCQOptionFour(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="relative p-6 flex-auto">
                        <label
                          className="block mb-2 text-sm font-bold text-gray-700"
                          htmlFor="examTitle"
                        >
                          MCQ Correct Answer
                        </label>
                        <input
                          className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-green-500 border-green-300 focus:shadow-outline"
                          type="text"
                          name="MCQCorrectAnswer"
                          value={MCQCorrectAnswer}
                          onChange={(e) => setMCQCorrectAnswer(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  )}

                  {/*body*/}
                  {/*footer*/}
                  <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                    <button
                      className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default AddQuestion;
